import { RECURRING_BILLING_FREQUENCY, TERM } from 'customer-data-objects/lineItem/PropertyNames';
import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
import { getMonthsPerBillingFrequency, getMonthsPerPeriod, getWeeksPerBillingFrequency, getWeeksPerPeriod, isWeeklyOrBiweeklyBillingFrequency, parsePeriodValue } from 'customer-data-properties/v2/utils/period';
import { MONTHS, WEEKS, YEARS } from '../../constants/TermLengthUnits';
const createTermProps = (term, termLengthUnit) => ({
  term,
  termLengthUnit
});
export const getTermPropsFromISO = periodISOString => {
  // a null term most likely means it was never set, or was deleted
  if (!periodISOString) {
    return createTermProps(null, null);
  }
  const period = parsePeriodValue(periodISOString);
  if ((period === null || period === void 0 ? void 0 : period.unit) === 'WEEKS') {
    return createTermProps(getWeeksPerPeriod(periodISOString), WEEKS);
  }
  const monthsPerTerm = period === null || period === void 0 ? void 0 : period.periodValue;
  const yearsPerTerm = monthsPerTerm ? monthsPerTerm / 12 : 0;

  // if term string exists but doesn't last a month or more
  // then the user probably inputted 0, so we should preserve
  // their input
  if (!!monthsPerTerm && monthsPerTerm < 1) {
    return createTermProps(0, null);
  }
  const showTermInYears = yearsPerTerm % 1 === 0;
  if (showTermInYears) {
    return createTermProps(yearsPerTerm, YEARS);
  }
  return createTermProps(monthsPerTerm !== null && monthsPerTerm !== void 0 ? monthsPerTerm : 0, MONTHS);
};
export const getTermHasLength = periodISOString => {
  var _parsePeriodValue;
  if (!periodISOString) {
    return false;
  }
  const periodValue = (_parsePeriodValue = parsePeriodValue(periodISOString)) === null || _parsePeriodValue === void 0 ? void 0 : _parsePeriodValue.periodValue;
  return !!periodValue && periodValue >= 1;
};
export function getNumberOfPayments(subject) {
  const termValue = getProperty(subject, TERM);
  const billingFrequencyValue = getProperty(subject, RECURRING_BILLING_FREQUENCY);

  // One time line items have a single payment
  if (!billingFrequencyValue) {
    return 1;
  }

  // If billing frequency is weekly, calculate number of payments in weeks
  if (isWeeklyOrBiweeklyBillingFrequency(billingFrequencyValue)) {
    const termInWeeks = getWeeksPerPeriod(termValue);
    if (!termInWeeks) {
      return null;
    }
    const billingFrequencyInWeeks = getWeeksPerBillingFrequency(billingFrequencyValue);
    return Math.ceil(termInWeeks / billingFrequencyInWeeks);
  }

  // Else calculate number of payments in months
  const termInMonths = getMonthsPerPeriod(termValue);
  if (!termInMonths) {
    return null;
  }
  const billingFrequencyInMonths = getMonthsPerBillingFrequency(billingFrequencyValue);
  return Math.ceil(termInMonths / billingFrequencyInMonths);
}